import { render, staticRenderFns } from "./BaseChartJS.vue?vue&type=template&id=0e5603ee&"
import script from "./BaseChartJS.vue?vue&type=script&lang=js&"
export * from "./BaseChartJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports